import { configureAppStore } from './SetupStore';

// Call the function once to create the store instance
const store = configureAppStore();

export default store;
